import "./Services.css";
import car from "../../images/grand.webp";
import city from "../../images/corola1.png";
import suv from "../../images/suv.png";
import mini from "../../images/download.png";
import van from "../../images/b2.png";
import { Link } from "react-router-dom";

function Services() {
  return (
    <>
      <div className="service">
        <div className="container-fluid">
          <div className="hero">
            <div className="row">
              <div className="col-lg-5 col-md-12">
                <div className="text">
                  <h1>
                    Explore Comfort Limo <span>Services</span>
                  </h1>
                  <div className="list">
                    <ul className="m-0 p-0">
                      <li>Experience our hassle-free booking system.</li>
                      <li>Select from our exclusive fleet.</li>
                      <li>
                        Each journey is special, thanks to our skilled and
                        experienced chauffeurs.
                      </li>
                      <li>
                        We guarantee transparent pricing with no hidden charges.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-12">
                <div className="image">
                  <img src={car} alt="car" className="car" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="city">
        <div className="box">
          <div className="left w-50">
            <img src={city} alt="city" />
          </div>
          <div className="right">
            <h3>Luxury City Ride</h3>
            <p>
              Relax in a luxurious ride around the city with an expert
              chauffeur. Our automated systems ensure you have the best
              experience possible. Book a one-way trip or arrange for a round
              trip for added convenience.
            </p>
            <Link className="boook" to={"/"}>
              Book Now
            </Link>
          </div>
        </div>
      </div>
      <div className="airport">
        <div className="box">
          <div className="left w-50">
            <img src={suv} alt="city" className="suv" />
          </div>
          <div className="right">
            <h3>Airport Limousine</h3>
            <p>
              Reserve your ride to and from Cairo International Airport, Sharm
              El Sheikh International Airport, Borg El Arab Airport , Hurghada
              Airport , or Sphinx Airport with Comfort Limo for a luxurious and
              unforgettable journey every time. We understand the challenges of
              other airport limousine services and are here to offer a superior
              experience.
            </p>
            <Link className="boook" to={"/"}>
              Book Now
            </Link>
          </div>
        </div>
      </div>
      <div className="city">
        <div className="box">
          <div className="left w-50">
            <img src={mini} alt="city" />
          </div>
          <div className="right">
            <h3>Travel In Style</h3>
            <p>
              Discover unparalleled safety, luxury, and comfort when traveling
              between cities with Comfort Limo. Rent a Comfort Limo vehicle and
              travel from anywhere in Cairo and Alex, to any location in Egypt.
              More cities will be added soon.
            </p>
            <Link className="boook" to={"/"}>
              Book Now
            </Link>
          </div>
        </div>
      </div>
      <div className="airport">
        <div className="box">
          <div className="left top w-50">
            <img src={van} alt="city" />
          </div>
          <div className="right pt-5">
            <h3>Comfort With Us</h3>
            <p>
              Experience unparalleled comfort in our modern, air-conditioned
              vehicles, making even the longest journeys feel effortless, Relax
              in our state-of-the-art, air-conditioned cars, where every trip is
              designed to be smooth and enjoyable, no matter the distance.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
